import React, { useCallback, useLayoutEffect, useState } from "react"
import { useRef } from "react"
import CommonProblemSolved from "./common-details/common-problem-solved"
import CommonOverView from "./common-details/common-overview"
// import CommonBeginning from "./common-details/common-beginning"
// import CommonProgress from "./common-details/common-progress"
import CommonDesignJourney from "./common-details/common-design-journey"
import CommonDevelopmentJourney from "./common-details/common-development-journey"
import CommonDesigns from "./common-details/common-designs"
import CommonImpact from "./common-details/common-impact"
import CommonAchievement from "./common-details/common-achievement"

const WrapperSlideComponent = ({ children, isFullWidth }) => {
  return (
    <div
      className={`${isFullWidth ? "xl:min-w-[100vw] 4xl:min-w-[1920px] " : ""}`}
    >
      {children}
    </div>
  )
}

const HorizontalScrollSection = ({ data }) => {
  const [scrollPosition, setScrollPosition] = useState(0)
  const containerRef = useRef(null)
  const [totalItemsWidth, setTotalItemsWidth] = useState(0)
  const handleScroll = useCallback(() => {
    const stickySections = document.querySelector(".sticky_wrap")
    if (!stickySections) return

    const containerWidth = Math.min(document.documentElement.offsetWidth, 1920)
    transform(stickySections)

    function transform(section) {
      const offsetTop = section.parentElement.offsetTop
      const scrollTop = document.documentElement.scrollTop // Get scroll position
      const maxWidth = totalItemsWidth - containerWidth
      let leftPosition = scrollTop - offsetTop
      leftPosition =
        leftPosition < 0 ? 0 : leftPosition > maxWidth ? maxWidth : leftPosition

      setScrollPosition(leftPosition)
    }
  }, [totalItemsWidth])

  useLayoutEffect(() => {
    if (containerRef.current) {
      setTotalItemsWidth(containerRef.current.scrollWidth)
    }
  }, [totalItemsWidth])

  useLayoutEffect(() => {
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [handleScroll])

  const totalScrollHeight = totalItemsWidth
  return (
    <section style={{ height: totalScrollHeight }}>
      <div className=" overflow-hidden w-full sticky_wrap sticky top-0 h-screen  ">
        <div
          style={{
            display: "flex",
            transition: "transform 0.5s ease",
            transform: `translateY( -50%)`,
            left: -scrollPosition,
          }}
          className="absolute top-2/4 left-0 right-0 h-full max-h-[1000px]"
        >
          <div ref={containerRef} className="flex w-max">
            <WrapperSlideComponent isFullWidth>
              <CommonOverView data={data.overviewData} />
            </WrapperSlideComponent>
            <WrapperSlideComponent>
              <CommonProblemSolved data={data.problemWeSolved} />
            </WrapperSlideComponent>
            {/* <WrapperSlideComponent>
              <CommonBeginning data={data.beginning} />
            </WrapperSlideComponent> */}
            {/* <WrapperSlideComponent>
              <CommonProgress data={data.progress} />
            </WrapperSlideComponent> */}
            {data.designJourney && (
              <WrapperSlideComponent>
                <CommonDesignJourney data={data.designJourney} />
              </WrapperSlideComponent>
            )}
            {data.developmentJourney && (
              <WrapperSlideComponent>
                <CommonDevelopmentJourney data={data.developmentJourney} />
              </WrapperSlideComponent>
            )}
            {data.achievement && (
              <WrapperSlideComponent>
                <CommonAchievement data={data.achievement} />
              </WrapperSlideComponent>
            )}
            <WrapperSlideComponent>
              <CommonDesigns data={data.designs} />
            </WrapperSlideComponent>
            <WrapperSlideComponent>
              <CommonImpact data={data.impact} />
            </WrapperSlideComponent>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HorizontalScrollSection
